export function Logo({ size = "md", withText = true }) {
  const dim = size === "sm" ? 20 : size === "lg" ? 32 : 26;
  return (
    <div className="flex items-center gap-2.5 select-none">
      <svg width={dim} height={dim} viewBox="0 0 32 32" fill="none" className="shrink-0">
        <rect x="1" y="1" width="30" height="30" rx="8" stroke="rgba(245,158,11,0.5)" strokeWidth="1.5" />
        <circle cx="16" cy="9" r="3" fill="#F59E0B" />
        <circle cx="9" cy="22" r="2.5" fill="#06B6D4" />
        <circle cx="23" cy="22" r="2.5" fill="#94A3B8" />
        <path d="M16 12 L9.5 19.5 M16 12 L22.5 19.5" stroke="rgba(255,255,255,0.35)" strokeWidth="1.4" />
      </svg>
      {withText && (
        <span className="font-head font-extrabold tracking-tight text-[0.95rem] text-white">
          INDEPENDENT
        </span>
      )}
    </div>
  );
}
